@if (authService.isSignedIn() && isReady()) {
    <div class="layout" [class.layout-with-admin-btn]="isAdmin() && !sidebarService.isAdminSidebarEnabled() && !sidebarService.isBelowTabletWidth()" data-testid="app-root">
        <app-sidebar />

        @if (isAdmin() && !sidebarService.isAdminSidebarEnabled() && !sidebarService.isBelowTabletWidth()) {
            <img src="assets/icons/admin-filled.svg" alt="Burger Icon" class="layout-admin-btn fly-in-from-right" (click)="sidebarService.enableAdminSidebar()" data-testid="app-root-admin-sidebar-toggle-button" />
        }

        <main class="main-content" [class.main-content-overlay]="(sidebarService.isNavSidebarEnabled() || sidebarService.isAdminSidebarEnabled()) && sidebarService.isBelowTabletWidth()">
            <div class="app-header">
                <app-topbar />
                <section class="search-top" [class.search-top-hidden]="sidebarService.isBelowMobileWidth()" [class.search-top-with-admin-sidebar]="sidebarService.isAdminSidebarEnabled() && !sidebarService.isBelowTabletWidth()">
                    <div class="search-top-container" [class.search-top-dynamic-margin]="!sidebarService.isBelowTabletWidth()">
                        <app-search-bar />
                        <div class="divider"></div>
                    </div>
                </section>
            </div>
            <div class="main-content-item" [class.main-content-item-below]="sidebarService.isBelowTabletWidth()" [class.main-content-item-with-admin-sidebar]="sidebarService.isAdminSidebarEnabled() && !sidebarService.isBelowTabletWidth()">
                <div
                    class="main-content-item-inner"
                    [class.main-content-item-dynamic-margin]="!sidebarService.isBelowTabletWidth()"
                    [class.main-content-item-full-screen]="sidebarService.isFullScreenRoute() && !sidebarService.isBelowTabletWidth()"
                >
                    @defer (when authService.finishedPermissions()) {
                        <router-outlet />
                    } @placeholder {
                        <app-loading-indicator [size]="'large'" [color]="'secondary'"></app-loading-indicator>
                    }
                </div>
            </div>
        </main>
        <app-admin-sidebar />
        <app-guided-trial-resume />
    </div>
} @else {
    <router-outlet />
}

<footer></footer>
